import { render, staticRenderFns } from "./PaymentStatusBadge.vue?vue&type=template&id=60604d6e&"
import script from "./PaymentStatusBadge.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports